// Hooks / Node modules / Styles
import { useEffect, useState } from "react";
import { Form, Input, TextArea, Button, sendToast } from "elseware-ui";
import * as Yup from "yup";

// Reducers / Actions
import { useCreateContactMutation } from "src/app/slices/api/contactApiSlide";

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";

// Sub-Components

// Data / Images / Icons
const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  message: "",
};

// Validation Schema
const validations = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  message: Yup.string()
    .required("Message is required")
    .min(10, "Message must be at least 10 characters"),
});

// Simulating user authentication state
const isLoggedIn = false; // Replace with actual auth check
const loggedInUser = { name: "John Doe", email: "johndoe@example.com" }; // Replace with actual user data

function P_Contact() {
  const [createContact, { isLoading, isSuccess, isError, error }] =
    useCreateContactMutation();
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const onSubmit = async (values) => {
    try {
      const processedValues = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        message: values.message,
      };

      const res = await createContact({ data: processedValues }).unwrap();

      if (res) {
        sendToast({
          status: "success",
          message: "Your message has been sent!",
        });
        setHasSubmitted(true); // Mark form as submitted
      }
    } catch (error) {
      sendToast({
        status: "error",
        message: error?.data?.message || "Failed to send message.",
      });
    }
  };

  useEffect(() => {
    if (isError && error) {
      sendToast({
        status: "error",
        message:
          error?.data?.message ||
          "An error occurred while sending the message.",
      });
    }
  }, [isError, error]);

  return (
    <DefaultLayout>
      <div className="max-w-md mx-auto p-10 local-theme-bg-md local-theme-border-md shadow-md rounded-md">
        <h2 className="text-2xl font-bold mb-3 local-theme-text-md text-center">
          Contact Me
        </h2>

        {hasSubmitted ? (
          // Success message instead of form
          <div className="text-center p-6 bg-green-100 text-green-700 border border-green-500 rounded-md">
            <h3 className="text-lg font-semibold">
              Thank you for reaching out!
            </h3>
            <p className="text-sm mt-2">
              Your message has been received. I'll get back to you as soon as
              possible.
            </p>
          </div>
        ) : (
          <>
            <div className="local-theme-text-sm text-center pb-4 text-sm w-4/5 mx-auto">
              For collaborations, project inquiries, or any questions, feel free
              to connect.
            </div>

            {!isLoggedIn && (
              <div className="local-theme-text-xs text-center pb-6 text-sm w-4/5 mx-auto">
                <strong>Tip:</strong> Log in or sign up for a better experience
                and faster responses.
              </div>
            )}

            <Form
              enableReinitialize={true}
              initialValues={
                isLoggedIn ? { ...loggedInUser, message: "" } : initialValues
              }
              validationSchema={validations}
              onSubmit={onSubmit}
            >
              <div className="flex flex-col gap-4">
                <div className="grid grid-cols-2 gap-4">
                  <Input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                  />
                  <Input type="text" name="lastName" placeholder="Last Name" />
                </div>
                <Input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  disabled={isLoggedIn}
                />
                <TextArea
                  name="message"
                  rows={5}
                  placeholder="Your Message"
                  limit={1000}
                />
                <Button
                  loading={isLoading}
                  type="submit"
                  text="Send Message"
                  variant="success"
                  size="lg"
                  shape="softRoundedSquare"
                  block
                />
              </div>
            </Form>

            {/* {!isLoggedIn && (
              <div className="text-center mt-4 text-sm">
                Don't have an account?{" "}
                <a href="/signup" className="text-blue-500">
                  Sign up
                </a>{" "}
                or{" "}
                <a href="/login" className="text-blue-500">
                  Log in
                </a>
                .
              </div>
            )} */}
          </>
        )}
      </div>
    </DefaultLayout>
  );
}

export default P_Contact;
